import { render, staticRenderFns } from "./CompanyRegistryModal.vue?vue&type=template&id=73df95d3&"
import script from "./CompanyRegistryModal.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports